import React from 'react';
import Grid from '@mui/material/Grid';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';

import fetchText from '../fetchText';

const compRPROG = (
  { proposition: { reprogDate, clientHasInformed } },
  classes
) =>
  <Grid
    key={'Artisan updates a prog'}
    container
    item
    xs={8}
    spacing={3}
    children={[
      reprogDate && {
        data: {
          title: 'Intervention a été reprogrammée',
          text: `à ${dayjs(reprogDate).format('DD/MM/YY à HH:mm')}`,
        },
      },
      {
        data: {
          title: 'Le client a été informé :',
          text: clientHasInformed ? 'Oui' : 'Non',
        },
      },
    ].map(fetchText(classes))}
  />;

export default compRPROG;
